import { createContext, useContext, useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const ThemeCtx = createContext({ dark: false, toggle: () => {} });

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => localStorage.getItem("beaichy_theme") === "dark" || (!localStorage.getItem("beaichy_theme") && window.matchMedia?.("(prefers-color-scheme: dark)").matches));
  useEffect(() => { document.documentElement.classList.toggle("dark", dark); localStorage.setItem("beaichy_theme", dark ? "dark" : "light"); }, [dark]);
  return <ThemeCtx.Provider value={{ dark, toggle: () => setDark((d) => !d) }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);

export function ThemeToggle({ className = "", full = false }) {
  const { dark, toggle } = useTheme();
  return (
    <button type="button" onClick={toggle} aria-label={dark ? "Tema chiaro" : "Tema scuro"} title={dark ? "Passa al tema chiaro" : "Passa al tema scuro"}
      className={`inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-2.5 py-1.5 text-xs font-medium text-slate-600 hover:text-slate-900 transition-colors ${full ? "w-full justify-start" : ""} ${className}`} data-testid="theme-toggle">
      {dark ? <Sun size={15} /> : <Moon size={15} />}{full && <span>{dark ? "Tema chiaro" : "Tema scuro"}</span>}
    </button>
  );
}
